// const LeaderboardPage = () => import('./list/LeaderboardPage.vue');

import LeaderboardPage from "./list/LeaderboardPage.vue";

const routes = [
  {
    path: '/leaderboard',
    name: 'leaderboard',
    component: LeaderboardPage,
    meta: {
      title: 'match',
      requiresAuth: true,
      headerColor: '#4b4ced',
    }
  }
];

export default routes;
